class SelectedFiltersComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const chip = event.target.closest('button.selected-filters__chip');
    if (!chip) return;

    const facetsForm = document.querySelector('facets-form-component');
    if (!facetsForm?.updateFiltersByURL) return;

    let url;
    if (chip.dataset.filterAll) {
      const newUrl = new URL(window.location.href);
      const paramName = chip.dataset.filterAll;
      [...newUrl.searchParams.keys()]
        .filter((k) => k.startsWith(paramName))
        .forEach((k) => newUrl.searchParams.delete(k));
      newUrl.searchParams.delete('page');
      url = newUrl.toString();
    } else if (this.dataset.singleSelection !== undefined && !chip.hasAttribute('aria-current')) {
      // Single-selection mode: clear all current values for this filter, then add only this one
      const allButton = this.querySelector('button[data-filter-all]');
      const paramName = allButton?.dataset.filterAll;
      if (paramName) {
        const chipUrl = new URL(chip.dataset.url, window.location.href);
        const currentUrl = new URL(window.location.href);
        // Determine which value this chip adds (present in chipUrl but not in currentUrl)
        const chipValues = chipUrl.searchParams.getAll(paramName);
        const currentValues = currentUrl.searchParams.getAll(paramName);
        const addedValues = chipValues.filter((v) => !currentValues.includes(v));
        // Build URL: remove all values for this filter, add only the new one
        const newUrl = new URL(window.location.href);
        [...newUrl.searchParams.keys()]
          .filter((k) => k.startsWith(paramName))
          .forEach((k) => newUrl.searchParams.delete(k));
        newUrl.searchParams.delete('page');
        addedValues.forEach((v) => newUrl.searchParams.append(paramName, v));
        url = newUrl.toString();
      } else {
        url = chip.dataset.url;
      }
    } else {
      url = chip.dataset.url;
    }

    if (!url) return;
    facetsForm.updateFiltersByURL(url);
  };
}

if (!customElements.get('selected-filters-component')) {
  customElements.define('selected-filters-component', SelectedFiltersComponent);
}
